import {MonoTypeOperatorFunction} from "rxjs";
import {tap} from "rxjs/operators";
import {transient} from "./transient";

export function log<Type>(name?: string): (subject:Type) =>Type {
  return transient(subject => console.log(name, subject))
}

export function logAsync<Type>(name?: string): MonoTypeOperatorFunction<Type>{
  return tap<Type>(log(name));
}
